import Chart from 'chart.js/auto';
import def_day_lines from './graph_utils.js';

export default function graph_temp(ser,dates,ff2d){

  var ff = new Array(ff2d.length);
  var ff2 = new Array(ff2d.length);
  for(let i=0; i < ff.length; i++){
    ff[i]=ff2d[i][0];
    ff2[i]=ff[i]-ff2d[i][1];
  }
  
  const dt = {
    labels: dates,
    datasets: [
      {
	label: 'Température',
	data: ff,
	fill: false,
	borderColor: 'rgb(58, 115, 214)',
	lineTension: 0.3
      },
      {
	label: 'Point de rosée',
	data: ff2,
	fill: false,
	borderColor: 'rgb(50, 191, 104)',
	lineTension: 0.3
      }
    ]
  };
  var ymin=Math.min(...ff2);
  var ymax=Math.max(...ff);
  var ann=[];
  const temp_30_line = {
    type: 'line',
    borderColor: 'red',
    borderWidth: 2,
    scaleID: 'y',
    value: 30
  };
  const temp_15_line = {
    type: 'line',
    borderColor: 'blue',
    borderWidth: 2,
    scaleID: 'y',
    value: 15
  };
  const temp_0_line = {
    type: 'line',
    borderColor: 'red',
    borderWidth: 2,
    scaleID: 'y',
    value: 0
  };
  const temp_minus_15_line = {
    type: 'line',
    borderColor: 'blue',
    borderWidth: 2,
    scaleID: 'y',
    value: -15
  };
  var tt=30
  if(tt>ymin && tt < ymax){
    ann.push(temp_30_line)
  }
  var tt=15
  if(tt>ymin && tt < ymax){
    ann.push(temp_15_line)
  }
  var tt=0
  if(tt>ymin && tt < ymax){
    ann.push(temp_0_line)
  }
  var tt=-15
  if(tt>ymin && tt < ymax){
    ann.push(temp_minus_15_line)
  }

  def_day_lines(dates,ann);
  
  const ctx = document.getElementById('id_series_canvas');
  if(ser.chart){
    ser.chart.destroy();
  }
  ser.chart = new Chart(ctx, {
    type: 'line',
    data: dt,
    options: {
      maintainAspectRatio: false,
      animations: false,
      responsive: true,
      title: {
	display: true,
	text: 'Chart.js Time Scale'
      },
      scales: {
	y: {
	  title: {
	    display: true,
	    text: '[C]'
	  }		    
	}
      },
      plugins: {
	annotation: {
	  adjustScaleRange: false,
	  annotations: ann
	},
	zoom: {
	  zoom: {
	    wheel: {
	      enabled: true
	    },
	    pinch: {
	      enabled: true
	    },
	    mode: "x",
	    speed: 100				    
	  },
	  pan: {
	    enabled: true,
	    mode: "x",
	    speed: 100
	  }
	}
      }
    }
  });
}

